// Lib
import { ListingUI,ListingSyncErrorsUI, ChangedInfoUI } from 'features/Dealers/Listings/state/types';
import { DealerListingsWithErrorsUI } from 'features/Dealers/Listings/state/types';
import { LMValidation } from 'features/Dealers/Listings/state/types';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';

export interface ActionGetListingsForDealerRequest extends Action {
    dealerId: string
}

export const getListingsForDealer = (dealerId: string): ActionGetListingsForDealerRequest => ({
    type: ACTIONS.GET_LISTINGS_FOR_DEALER_API_REQUEST,
    dealerId
});

export interface ActionGetListingsForDealerRequestSuccess extends Action {
    listings: ListingUI[]
}

export const getListingsForDealerSuccess = (listings: ListingUI[]): ActionGetListingsForDealerRequestSuccess => ({
    type: ACTIONS.GET_LISTINGS_FOR_DEALER_API_SUCCESS,
    listings
});

export const getListingsForDealerError = (error): Action & { error: any } => ({
    type: ACTIONS.GET_LISTINGS_FOR_DEALER_API_ERROR,
    error
});

//CURRENT SELECTED LISTING
export interface ActionEditCurrentSelectedListing extends Action {
    listingId
}
export const editCurrentSelectedListing = (listingId?: string): ActionEditCurrentSelectedListing => ({
    type: ACTIONS.EDIT_CURRENT_SELECTED_LISTING,
    listingId
});

//LISTING_SYNC_ERRORS
export interface ActionGetListingSyncErrorsRequest extends Action {
    listingId: string
}

export const getListingSyncErrors = (listingId: string): ActionGetListingSyncErrorsRequest => ({
    type: ACTIONS.GET_LISTING_SYNC_ERRORS_API_REQUEST,
    listingId
});

export interface ActionGetListingSyncErrorsRequestSuccess extends Action {
    listingSyncErrors: ListingSyncErrorsUI
}

export const getListingSyncErrorsSuccess = (listingSyncErrors: ListingSyncErrorsUI): ActionGetListingSyncErrorsRequestSuccess => ({
    type: ACTIONS.GET_LISTING_SYNC_ERRORS_API_SUCCESS,
    listingSyncErrors
});

export const getListingSyncErrorsError = (error): Action & { error: any } => ({
    type: ACTIONS.GET_LISTING_SYNC_ERRORS_API_ERROR,
    error
});

//DEALER_LISTINGS_WITH_ERRORS
export interface ActionGetDealerListingsWithErrorsRequest extends Action {
    dealerId: string
}

export const getDealerListingsWithErrors = (dealerId: string): ActionGetDealerListingsWithErrorsRequest => ({
    type: ACTIONS.GET_DEALER_LISTINGS_WITH_ERRORS_API_REQUEST,
    dealerId
});

export interface ActionGetDealerListingsWithErrorsRequestSuccess extends Action {
    syncErrors: DealerListingsWithErrorsUI[]
}

export const getDealerListingsWithErrorsSuccess = (syncErrors: DealerListingsWithErrorsUI[]): ActionGetDealerListingsWithErrorsRequestSuccess => ({
    type: ACTIONS.GET_DEALER_LISTINGS_WITH_ERRORS_API_SUCCESS,
    syncErrors
});

export const getDealerListingsWithErrorsError = (error): Action & { error: any } => ({
    type: ACTIONS.GET_DEALER_LISTINGS_WITH_ERRORS_API_ERROR,
    error
});

//LISTING CHANGED
export const listingsChanges = (dealerId: string): ActionGetListingsForDealerRequest => ({
    type: ACTIONS.GET_LISTINGS_CHANGES_API_REQUEST,
    dealerId
});

export interface ActionListingsChangesRequestSuccess extends Action {
    listingsChanges?: ChangedInfoUI
}

export const listingsChangesSuccess = (listingsChanges?: ChangedInfoUI): ActionListingsChangesRequestSuccess => ({
    type: ACTIONS.GET_LISTINGS_CHANGES_API_SUCCESS,
    listingsChanges
});

export const listingsChangesError = (error): Action & { error: any } => ({
    type: ACTIONS.GET_LISTINGS_CHANGES_API_ERROR,
    error
});


//CHATMETER LISTING

export interface ActionUseLocationAPI extends Action {    
    iddealer: string
    locationId:string
    accountId:string
    restore: boolean
}


export const updateLocationAPI = (iddealer: string, locationId:string, accountId:string, restore:boolean): ActionUseLocationAPI => ({
    type: ACTIONS.USECHATMETERLOCATION_API_REQUEST,    
    iddealer,
    locationId,
    accountId,
    restore

});

export const updateLocationAPISuccess = (listings: ListingUI[]): ActionGetListingsForDealerRequestSuccess => ({
    type: ACTIONS.USECHATMETERLOCATION_API_SUCCESS,
    listings
});


export const updateLocationAPIError = (error: any): Action => ({
    type: ACTIONS.USECHATMETERLOCATION_API_ERROR,
});

export interface ActionGetLMValidationAPI extends Action {
}

export const getLMValidationAPI = (): ActionGetLMValidationAPI => ({
    type: ACTIONS.GET_LMVALIDATION_API_REQUEST,
});

export interface ActionGetLMValidationAPISuccess extends Action {
    lmValidation: LMValidation
}

export const getLMValidationAPISuccess = (lmValidation: LMValidation): ActionGetLMValidationAPISuccess => ({
    type: ACTIONS.GET_LMVALIDATION_API_SUCCESS,
    lmValidation
});

export const getLMValidationAPIError = (): Action => ({
    type: ACTIONS.GET_LMVALIDATION_API_ERROR,
});

